import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollService {
  public logoClicked = false;

  markLogoClick() {
    this.logoClicked = true;
  }

  resetLogoClick() {
    this.logoClicked = false;
  }
}